import { CalendarOutlined, EnvironmentOutlined } from '@ant-design/icons'
import { Divider, Flex } from 'antd'
import { useTheme } from 'antd-style'

import {
  ConsultationStatus,
  GetConsultationListResponseItem
} from 'src/api/requests'
import { Text } from 'src/components'
import { formatDate, hourMinutesFormat, monthNameWithDay } from 'src/libs'
import { useLocales } from 'src/locales'

import { ConsultationStatusTag } from './ConsultationStatusTag'
import { useStyles } from './styles'

type Props = {
  data?: GetConsultationListResponseItem
}

export const AppointmentCard = ({ data }: Props) => {
  const isFinished = data?.status === ConsultationStatus.PRESENT

  const { styles } = useStyles({ isFinished })
  const { t } = useLocales()
  const palette = useTheme()

  return (
    <Flex className={styles.card} align="center" justify="space-between">
      <Flex align="center">
        <Flex vertical gap={8}>
          <Flex gap={4} align="start" className={styles.text}>
            <CalendarOutlined />
            <Text>{t('appointments.date_and_time')}</Text>
          </Flex>
          <Text weight={600} size="xl" color={palette.colorTextHeading}>
            {formatDate(data?.consultationDate, monthNameWithDay)},{' '}
            {t('common.hour').toLowerCase()}{' '}
            {formatDate(data?.consultationDate, hourMinutesFormat)}
          </Text>
        </Flex>

        <Divider type="vertical" className={styles.divider} />

        <Flex vertical gap={8}>
          <Flex gap={4} align="start" className={styles.text}>
            <EnvironmentOutlined />
            <Text>{t('organizational_structure.name')}</Text>
          </Flex>
          <Text weight={600} size="xl" color={palette.colorTextHeading}>
            {data?.legalEntity?.name}
          </Text>
        </Flex>

        <Divider type="vertical" className={styles.divider} />

        <Flex vertical gap={8}>
          <Flex gap={4} align="start" className={styles.text}>
            <Text>{t('consultations.consultation_type')}</Text>
          </Flex>
          <Text weight={600} size="xl" color={palette.colorTextHeading}>
            {data?.consultationType
              ? t(`consultation_form.type.${data?.consultationType}`)
              : '-'}
          </Text>
        </Flex>
      </Flex>

      <Flex align="center">
        <Divider type="vertical" className={styles.divider} />
        <Flex vertical gap={8} align="center">
          <ConsultationStatusTag status={data?.status} />
        </Flex>
      </Flex>
    </Flex>
  )
}
